import { createElement, type HTMLAttributes } from 'react';
import { sanitizeHtml } from '@/lib/sanitize-html';

type SafeHtmlProps = HTMLAttributes<HTMLElement> & {
  html: string;
  as?: 'div' | 'span' | 'article' | 'p';
};

export function SafeHtml({ html, as = 'div', ...props }: SafeHtmlProps) {
  return createElement(as, {
    ...props,
    dangerouslySetInnerHTML: { __html: sanitizeHtml(html) },
  });
}
